import { z } from "zod";
import { setMeasurements } from "./measurement-contract";

const nullableText = z.string().max(1000).nullable().optional();
const setState = setMeasurements.extend({
  id: z.string().min(1).max(200),
  setNumber: z.number().int().min(1).max(200),
  weight: setMeasurements.shape.weight.unwrap(),
  reps: setMeasurements.shape.reps.unwrap(),
  duration: setMeasurements.shape.duration.unwrap(),
  restSeconds: setMeasurements.shape.restSeconds.unwrap(),
  isCompleted: z.boolean(),
  completedAt: z.iso.datetime().nullable().optional(),
  isPR: z.boolean().optional(),
});

export const workoutSessionStateSchema = z
  .object({
    workoutId: z.string().min(1).max(200).nullable(),
    workoutName: z.string().max(200),
    accountId: z.string().min(1).max(200).optional(),
    weightUnit: z.enum(["kg", "lb"]).nullable().optional(),
    startedAt: z.iso.datetime().nullable(),
    endedAt: z.iso.datetime().optional(),
    disposition: z.enum(["completed", "discarded"]).optional(),
    appliedCommandIds: z
      .array(z.string().min(1).max(200))
      .max(10000)
      .optional(),
    exercises: z
      .array(
        z.object({
          id: z.string().min(1).max(200),
          exerciseId: z.string().max(200).nullable(),
          customExerciseId: z.string().max(200).nullable(),
          name: z.string().min(1).max(200),
          primaryMuscle: nullableText,
          equipment: nullableText,
          imageUrl: nullableText,
          gifUrl: nullableText,
          supersetGroup: nullableText,
          trackMode: z.enum(["reps", "time", "distance"]).optional(),
          sets: z.array(setState).max(200),
          previousSets: z
            .array(
              z.object({
                setNumber: z.number().int().min(1).max(200),
                weight: setMeasurements.shape.weight.unwrap(),
                reps: setMeasurements.shape.reps.unwrap(),
                duration: setMeasurements.shape.duration,
                distance: setMeasurements.shape.distance,
                weightUnit: z.enum(["kg", "lb"]).nullable().optional(),
              }),
            )
            .max(200)
            .optional(),
          isLoadingPreviousSets: z.boolean().optional(),
        }),
      )
      .max(100),
    restTimer: z.object({
      active: z.boolean(),
      restEndTime: z.number().finite().nonnegative().nullable(),
      totalSeconds: z.number().finite().min(0).max(86400),
    }),
  })
  .superRefine((session, ctx) => {
    if (
      Boolean(session.workoutId) !== Boolean(session.startedAt) ||
      (session.endedAt &&
        (!session.startedAt ||
          Date.parse(session.endedAt) < Date.parse(session.startedAt))) ||
      (session.restTimer.active && session.restTimer.restEndTime == null)
    )
      ctx.addIssue({ code: "custom", message: "Invalid workout lifecycle" });
    const ids = session.exercises.flatMap((ex) => [
      ex.id,
      ...ex.sets.map((set) => set.id),
    ]);
    if (new Set(ids).size !== ids.length)
      ctx.addIssue({ code: "custom", message: "Duplicate workout identity" });
  });
